
import { AudioVideoFacade } from 'amazon-chime-sdk-js';
import { useEffect, useState } from 'react';

type SpeakingMap = Record<string, boolean>;

export const useSpeakingIndicator = (
  audioVideo: AudioVideoFacade | null
) => {
  const [speakingAttendees, setSpeakingAttendees] = useState<SpeakingMap>({});

  useEffect(() => {
    if (!audioVideo) return;

    const updateSpeaking = (attendeeId: string, volume: number | null, muted: boolean) => {
      setSpeakingAttendees(prev => ({
        ...prev,
        [attendeeId]: !muted && volume !== null && volume > 0.1,
      }));
    };

    const handlePresence = (attendeeId: string, present: boolean) => {
      if (present) {
        audioVideo.realtimeSubscribeToVolumeIndicator(attendeeId, (volume: any, muted: any) => {
          updateSpeaking(attendeeId, volume, muted);
        });
      } else {
        setSpeakingAttendees(prev => {
          const updated = { ...prev };
          delete updated[attendeeId];
          return updated;
        });
      }
    };

    audioVideo.realtimeSubscribeToAttendeeIdPresence(handlePresence);

    return () => {
      audioVideo.realtimeUnsubscribeToAttendeeIdPresence(handlePresence);
    };
  }, [audioVideo]);

  return speakingAttendees;
};
